import React, { useEffect, useState, useRef } from 'react';
import styles from "./InputSearch.module.scss";
import {ErrorMsg} from "@onegovbugs/onegov-react-components";

export const InputSearch = ({inputSearchHandler, speciesCode, searchTextError}) => {

    console.log(speciesCode);
    const [enteredFilter, setEnteredFilter] = useState(speciesCode ? speciesCode : '');
    const inputRef = useRef();

    useEffect(() => {

        const timer = setTimeout(() => {
            if (enteredFilter === inputRef.current.value) {

                if(enteredFilter !== speciesCode)
                {
                    inputSearchHandler(enteredFilter);
                }
            }
          }, 500);
          return () => {
            clearTimeout(timer);
          };     
      }, [enteredFilter, inputRef]);    

    
  

    return (


        <React.Fragment>
         <input
            id="inputSpeciesCode"
            className={`${styles.inputBox}`}
            ref={inputRef}
            value={enteredFilter}
            //placeholder={"Species Code"}
            onChange={event => setEnteredFilter(event.target.value)}
        /> 
        {/* { 
         (searchTextError && searchTextError.showError) &&
         <div>asdadas{searchTextError.errorMessage}</div>
        } */}
        {searchTextError && searchTextError.showError ? (
            <ErrorMsg className={"ErrorMsg_error"}
            type={"error"}
            description={searchTextError.errorMessage}
            />
        ) : null}         
        </React.Fragment>


    )
}